const DAY = 86_400_000;
export function validOpportunityTime(value) {
    const parsed = value ? Date.parse(value) : Number.NaN;
    return Number.isFinite(parsed) ? parsed : undefined;
}
export function opportunityTimingStage(opportunity, now = Date.now()) {
    const eventStart = validOpportunityTime(opportunity.eventStart);
    const outreachStart = validOpportunityTime(opportunity.outreachStart);
    const outreachEnd = validOpportunityTime(opportunity.outreachEnd);
    const openingSoon = validOpportunityTime(opportunity.timing?.openingSoonStart)
        ?? (outreachStart != null ? outreachStart - 60 * DAY : undefined);
    if (eventStart != null && now >= eventStart)
        return 'too-late';
    if (outreachEnd != null && now > outreachEnd)
        return 'too-late';
    if (outreachStart != null && now >= outreachStart && (outreachEnd == null || now <= outreachEnd))
        return 'contact-now';
    if (openingSoon != null && outreachStart != null && now >= openingSoon && now < outreachStart)
        return 'opening-soon';
    if (outreachStart != null && now < (openingSoon ?? outreachStart))
        return 'too-early';
    // New press coverage does not establish a creative procurement window.
    if (opportunity.timing?.model === 'News signal — research needed')
        return 'unknown';
    if (opportunity.status === 'contact-now')
        return 'contact-now';
    if (opportunity.status === 'opening-soon')
        return 'opening-soon';
    if (opportunity.status === 'too-late' || opportunity.status === 'closed')
        return 'too-late';
    if (opportunity.status === 'research' || opportunity.status === 'soft-intro')
        return 'too-early';
    return 'unknown';
}
export function daysUntilOutreachStart(opportunity, now = Date.now()) {
    const start = validOpportunityTime(opportunity.outreachStart);
    return start != null && start > now ? (start - now) / DAY : undefined;
}
export function distanceToOutreachWindow(opportunity, now = Date.now()) {
    const start = validOpportunityTime(opportunity.outreachStart);
    const end = validOpportunityTime(opportunity.outreachEnd);
    if (start == null && end == null)
        return Number.POSITIVE_INFINITY;
    if (start != null && end != null && now >= start && now <= end)
        return 0;
    if (start != null && now < start)
        return start - now;
    if (end != null && now > end)
        return now - end;
    return 0;
}
export function isOpportunitySnoozed(opportunity, now = Date.now()) {
    const until = validOpportunityTime(opportunity.snoozedUntil);
    return until != null && until > now;
}
export function opportunityTimingLabel(stage) {
    switch (stage) {
        case 'too-early': return 'Too early';
        case 'opening-soon': return 'Planning window';
        case 'contact-now': return 'Contact now';
        case 'too-late': return 'Too late';
        default: return 'Timing unknown';
    }
}
